{
  "EMOJI": {
    "PLACEHOLDER": "絵文字を検索",
    "NOT_FOUND": "検索条件に一致する絵文字が見つかりません",
    "REMOVE": "削除"
  }
}
